import { render, staticRenderFns } from "./drawAddNum.vue?vue&type=template&id=6d9bb34e&scoped=true"
import script from "./drawAddNum.vue?vue&type=script&lang=js"
export * from "./drawAddNum.vue?vue&type=script&lang=js"
import style0 from "./drawAddNum.vue?vue&type=style&index=0&id=6d9bb34e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9bb34e",
  null
  
)

export default component.exports